export * from './FileTypeTableIcon';
export * from './FileTypeTableIcon16Light';
export * from './FileTypeTableIcon16Regular';
export * from './FileTypeTableIcon16Solid';
export * from './FileTypeTableIcon20Light';
export * from './FileTypeTableIcon20Regular';
export * from './FileTypeTableIcon20Solid';
export * from './FileTypeTableIcon24Regular';
export * from './FileTypeTableIcon24Solid';
export * from './FileTypeTableIcon32Regular';
export * from './FileTypeTableIcon64Regular';
